// @flow

import styled, { css } from 'styled-components';
import { media } from '../../helpers';
import type { Theme } from '../../types';

type Props = {
  cellWidth?: number,
};

const Cell: any = styled<any, Theme, Props>('td')`
  ${props => props.cellWidth && css`
    width: ${props.cellWidth}%;
  `}
  position: relative;
  vertical-align: top;
  padding: 1rem;
  border-bottom: 1px solid ${props => props.theme.table.borderColor};
  border-left: 1px solid ${props => props.theme.table.borderColor};
  color: ${props => props.theme.table.titleCell.color};
  text-align: center;
  &:nth-child(2) {
    border-left: 0;
  }

  &:first-child {
    border-left: 0;
  }

  ${media.lg(css`
    &:nth-child(2) {
      border-left: 1px solid ${props => props.theme.table.borderColor};
    }
  `)}
`;

const TitleCell = styled<typeof Cell, Theme, _>(Cell)`
  font-weight: bold;
  background-color: ${props => props.theme.table.titleCell.backgroundColor};
  font-size: 1.5rem;
  color: ${props => props.theme.table.titleCell.color};
  text-align: left;
`;

const ResponsiveCell = styled<typeof TitleCell, Theme, _>(TitleCell)`
  display: none;

  ${media.lg(css`
    display: table-cell;
  `)}
`;

export {
  TitleCell,
  ResponsiveCell,
};

export default Cell;
